import { useState } from "react";
import { useSnackbar } from "contexts/SnackbarContext";
import { openRazorpayCheckout } from "utils/razorpay";
import { createOcrSubscriptionOrder, verifyOcrPayment } from "../service";

export default function useOcrPayment({ disputeId, profile }) {
  const { showSnackbar } = useSnackbar();
  const [paying, setPaying] = useState(false);

  const prefill = {
    name: [profile?.user?.first_name, profile?.user?.last_name].filter(Boolean).join(" "),
    email: profile?.user?.email,
    contact: profile?.phone_number,
  };

  const payForOcr = async (amount) => {
    if (!amount) {
      showSnackbar("Payment amount not available. Please try again.", "error");
      return false;
    }

    setPaying(true);
    try {
      const orderRes = await createOcrSubscriptionOrder({ amount, dispute_id: disputeId });
      const order = orderRes.data || {};

      if (!order.order_id || !order.key) {
        showSnackbar(order.message || "Could not start the payment. Please try again.", "error");
        return false;
      }

      return await new Promise((resolve) => {
        openRazorpayCheckout({
          key: order.key,
          order_id: order.order_id,
          amount: order.amount,
          currency: order.currency,
          description: "OCR processing charges",
          prefill,
          onSuccess: (response) => {
            verifyOcrPayment({
              profile_id: profile?.id,
              dispute_id: disputeId,
              razorpay_payment_id: response.razorpay_payment_id,
              razorpay_order_id: response.razorpay_order_id,
              razorpay_signature: response.razorpay_signature,
            })
              .then((verifyRes) => {
                if (verifyRes.data?.success) {
                  showSnackbar(verifyRes.data?.message || "Payment verified successfully.", "success");
                  resolve(true);
                } else {
                  showSnackbar(verifyRes.data?.error || "Payment verification failed.", "error");
                  resolve(false);
                }
              })
              .catch((err) => {
                // 400s are already toasted by the global axios interceptor.
                if (err.response?.status !== 400) {
                  showSnackbar("Payment verification failed.", "error");
                }
                resolve(false);
              });
          },
          onFailure: (err) => {
            showSnackbar(err?.error?.description || "Payment failed. Please try again.", "error");
            resolve(false);
          },
          onDismiss: () => resolve(false),
        }).catch((err) => {
          showSnackbar(err.message || "Could not open the payment window.", "error");
          resolve(false);
        });
      });
    } catch (err) {
      if (err.response?.status !== 400) {
        showSnackbar(
          err.response?.data?.error || err.response?.data?.message || "Could not start the payment.",
          "error"
        );
      }
      return false;
    } finally {
      setPaying(false);
    }
  };

  return { payForOcr, paying };
}
